const content = {
  inputs: [
    {
      placeholder: "Emaill",
      name: "email",
      type: "email",
    },

    {
      placeholder: "Password",
      name: "password",
      type: "password",
    },
    {
      placeholder: "Project Name",
      name: "project",
      type: "text",
    },
  ],
};

export default content;
